import { __read } from "tslib";
import React from "react";
import moment from "moment";
import Table, { CellStatus } from "./BaseTable";
import { useTranslation } from "../../i18n";
import { getNow, isAfter, isBefore, isSame } from "../../datepicker/util";
export function YearTable(_a) {
    var current = _a.current, _b = _a.onCurrentChange, onCurrentChange = _b === void 0 ? function () { return null; } : _b, range = _a.range, _c = _a.onSelect, onSelect = _c === void 0 ? function () { return null; } : _c, _d = _a.cellStatus, cellStatus = _d === void 0 ? function () { return CellStatus.Common; } : _d;
    var t = useTranslation();
    var year = current.year();
    var now = getNow(current);
    var start = year - (year % 20);
    var end = start + 20 - 1;
    // 5 * 4
    function genTable() {
        return "abcde".split("").map(function (_, i) {
            return Array(4)
                .fill(0)
                .map(function (_, j) { return i * 4 + j + start; });
        });
    }
    function renderYear() {
        return start + "-" + end;
    }
    var _e = __read(range || [null, null], 2), rangeMin = _e[0], rangeMax = _e[1];
    function isValid(date) {
        if (moment.isMoment(rangeMin) && isAfter(rangeMin, date, "year")) {
            return false;
        }
        if (moment.isMoment(rangeMax) && isBefore(rangeMax, date, "year")) {
            return false;
        }
        return true;
    }
    return (React.createElement(Table, { type: "year", caption: renderYear(), jumperOptions: {
            onNext: function () { return onCurrentChange(moment(current).add(20, "year")); },
            onPrev: function () { return onCurrentChange(moment(current).subtract(20, "year")); },
            onCurrent: function () { return onCurrentChange(now); },
            isCurrent: now.year() >= start && now.year() <= end,
            nextDisabled: moment.isMoment(rangeMax) && rangeMax.year() <= end,
            prevDisabled: moment.isMoment(rangeMin) && rangeMin.year() >= start,
            nextTitle: t.nextTwentyYears,
            prevTitle: t.prevTwentyYears,
            curTitle: t.curTwentyYears,
        } }, genTable().map(function (row, index) { return (React.createElement(Table.Row, { key: index }, row.map(function (year) {
        var y = moment(current).set({
            year: year,
            month: 0,
            date: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        });
        return (React.createElement(Table.Cell, { key: year, name: y.format("YYYY"), value: y, onSelect: onSelect, isNow: isSame(y, now, "year"), status: cellStatus(y), disabled: !isValid(y) }));
    }))); })));
}
YearTable.displayName = "YearTable";
//# sourceMappingURL=YearTable.js.map